import { externalLinks } from "@/utils/external-links";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, IconButton, Link } from "@mui/material";

export function SocialIcons() {
  return (
    <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
      <Link href={externalLinks.instagram} target="_blank" rel="noopener" aria-label="Instagram">
        <IconButton color="secondary" size="large">
          <InstagramIcon />
        </IconButton>
      </Link>

      <Link href={externalLinks.whatsapp} target="_blank" rel="noopener" aria-label="WhatsApp">
        <IconButton color="success" size="large">
          <WhatsAppIcon />
        </IconButton>
      </Link>
    </Box>
  );
}
